import { Controller } from '@hotwired/stimulus';

// Message fermé par son bouton.
export default class extends Controller {
    close() {
        this.element.remove();
    }
}
